<script>
import ButtonIcon from "@/components/molecules/button-icon";
import Container from "@/components/atoms/container";

export default {
  name: "HomeAchatExpressMobile",
  components: { ButtonIcon, Container }
};
</script>
<template>
  <Container>
    <div class="u-flex u-flex-justify-between u-mb-sm">
      <ButtonIcon
        icon-name="basket"
        icon-color="primary"
        variant="border-lighter"
        radius="md"
        outline
        full-width
        size="md"
        align="left"
        class="c-quicknav__button u-flex-item-fluid u-mr-xs"
        to="/menu-c-176361"
      >
        <span class="u-font-14 u-font-12@xs">Nos&nbsp;rayons</span>
      </ButtonIcon>

      <ButtonIcon
        icon-name="list-edit"
        icon-color="primary"
        variant="border-lighter"
        radius="md"
        outline
        full-width
        size="md"
        align="left"
        class="c-quicknav__button u-flex-item-fluid u-ml-xs"
        to="/mon-compte/mes-listes-de-courses"
      >
        <span class="u-font-14 u-font-12@xs">Mes&nbsp;listes</span>
      </ButtonIcon>
    </div>
    <div class="u-flex u-flex-justify-between">
      <ButtonIcon
        icon-name="heart"
        icon-color="primary"
        variant="border-lighter"
        radius="md"
        outline
        full-width
        size="md"
        align="left"
        class="c-quicknav__button u-flex-item-fluid u-mr-xs"
        to="/mon-compte/mes-produits-habituels"
      >
        <span class="u-font-14 u-font-12@xs">Mes&nbsp;produits habituels</span>
      </ButtonIcon>
      <ButtonIcon
        icon-name="timer"
        icon-color="primary"
        variant="border-lighter"
        radius="md"
        outline
        full-width
        size="md"
        align="left"
        class="c-quicknav__button u-flex-item-fluid u-ml-xs"
        to="/mon-compte/mes-commandes"
      >
        <span class="u-font-14 u-font-12@xs">Mes&nbsp;dernières commandes</span>
      </ButtonIcon>
    </div>
  </Container>
</template>
<style lang="scss" scoped>
.c-quicknav__button {
  line-height: 1;
  min-height: 5.6rem;
}
</style>
